module.exports = __webpack_public_path__ + "img/img-tennis-d.ec160878.png";